'use strict';

// import Swiper Styles
import 'swiper/css/bundle';
// import Swiper
import Swiper, {
  SwiperOptions,
  Navigation,
  Scrollbar,
  Autoplay,
  EffectFade,
  Pagination,
  Thumbs,
} from 'swiper';
// Enable Swiper Modules
Swiper.use([Scrollbar, Navigation, Autoplay, EffectFade, Pagination, Thumbs]);

const swiperParams: SwiperOptions = {
  slidesPerView: 1,
  grabCursor: true,
  navigation: {
    nextEl: '.commonPageGallerySlider .swiper-button-next',
    prevEl: '.commonPageGallerySlider .swiper-button-prev',
  },
};

const swiperParamsSingleOther: SwiperOptions = {
  slidesPerView: 'auto',
  grabCursor: true,
  spaceBetween: 24,
  navigation: {
    nextEl: '.commonPageGallerySlider .swiper-button-next',
    prevEl: '.commonPageGallerySlider .swiper-button-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
  },
};

const swiperParamsSingle: SwiperOptions = {
  slidesPerView: 1,
  grabCursor: true,
  navigation: {
    nextEl: '.commonPageGallerySlider .swiper-button-next',
    prevEl: '.commonPageGallerySlider .swiper-button-prev',
  },
};

const swiperParamsThumb: SwiperOptions = {
  slidesPerView: 5,
  spaceBetween: 5,
  loop: true,
  grabCursor: true,
  breakpoints: {
    768: {
      spaceBetween: 13,
    },
  },
};

const swiperParamsSingleThumb: SwiperOptions = {
  slidesPerView: 4,
  spaceBetween: 11,
  // loop: true,
  grabCursor: true,
  breakpoints: {
    768: {
      spaceBetween: 20,
    },
  },
};

const swiperParamsThumbFront: SwiperOptions = {
  slidesPerView: 6,
  spaceBetween: 7,
  // loop: true,
  grabCursor: true,
  breakpoints: {
    768: {
      spaceBetween: 18,
    },
  },
};

const swiperParamsPageHead: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 24,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      spaceBetween: 40,
    },
  },
};

const swiperParamsPageFoot: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 20,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    768: {
      spaceBetween: 60,
    },
  },
};

const swiperParamsCommonHero: SwiperOptions = {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 2000,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
};

const swiperParamsCommonHeroFront: SwiperOptions = {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  // loopAdditionalSlides: 1,
  speed: 2000,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
};

const swiperParamsSunReport: SwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 40,
  grabCursor: true,
  navigation: {
    nextEl: '.tempSunReportSlider .swiper-button-next',
    prevEl: '.tempSunReportSlider .swiper-button-prev',
  },
};

const initSwiper = () => {
  const swiperThumb = new Swiper(
    '.commonPageGalleryThumbSwiper',
    swiperParamsThumb
  );
  const swiperSingleThumb = new Swiper(
    '.tempSingleGalleryThumbSlider > .tempSingleGalleryThumbSwiper',
    swiperParamsSingleThumb
  );
  const swiperThumbFront = new Swiper(
    '.commonPageHeroThumbSwiper',
    swiperParamsThumbFront
  );

  const mySwiper_thumb = swiperThumb;
  swiperParams.thumbs = {
    swiper: mySwiper_thumb,
  };

  const mySwiper_signleThumb = swiperSingleThumb;
  swiperParamsSingle.thumbs = {
    swiper: mySwiper_signleThumb,
  };

  const mySwiper_frontThumb = swiperThumbFront;
  swiperParamsCommonHeroFront.thumbs = {
    swiper: mySwiper_frontThumb,
  };
  const swiper = new Swiper('.commonPageGallerySwiper', swiperParams);
  if (swiper.slides.length <= 1) {
    const swiperController = document.querySelector(
      '.commonPageGallerySlider .swiper-controller'
    ) as HTMLElement;
    if (swiperController) {
      swiperController.style.display = 'none';
    }
  }
  const swiperSingle = new Swiper(
    '.tempSingleGallerySwiper',
    swiperParamsSingle
  );
  if (swiperSingle.slides.length) {
    const singleBody = document.querySelector(
      '.tempSingleGallerySlider .swiper-controller'
    ) as HTMLElement;
    if (singleBody) {
      singleBody.style.display = 'block';
    }
  }
  const swiperSingleOther = new Swiper(
    '.tempSingleOtherSwiper',
    swiperParamsSingleOther
  );
  if (swiperSingleOther.slides.length <= 1) {
    {
      const singleOtherBody = document.querySelector(
        '.tempSingleOtherBody .swiper-controller'
      ) as HTMLElement;
      if (singleOtherBody) {
        singleOtherBody.style.display = 'none';
      }
    }
  }
  const swiperPageHead = new Swiper('.pageHeadSwiper', swiperParamsPageHead);
  if (swiperPageHead.slides.length <= 1) {
    const pageHeadNav = document.querySelector(
      '#pageHead .swiper-controller'
    ) as HTMLElement;
    if (pageHeadNav) {
      pageHeadNav.style.display = 'none';
    }
  }

  const swiperPageSunRepo = new Swiper(
    '.commonPageReportSwiper',
    swiperParamsSunReport
  );
  const swiperFrontTopic = new Swiper(
    '.frontPageTopicsSwiper',
    swiperParamsPageHead
  );
  if (swiperFrontTopic.slides.length <= 1) {
    const frontTopicNav = document.querySelector(
      '#topics .swiper-controller'
    ) as HTMLElement;
    if (frontTopicNav) {
      frontTopicNav.style.display = 'none';
    }
  }
  const swiperPageFoot = new Swiper('.pageFootSwiper', swiperParamsPageFoot);
  const swiperCommonHero = new Swiper(
    '.commonPageHeroSwiper',
    swiperParamsCommonHero
  );
  const swiperCommonFrontHero = new Swiper(
    '.commonPageHeroSlider > .commonPageHeroSwiper',
    swiperParamsCommonHeroFront
  );
};

window.addEventListener('DOMContentLoaded', () => {
  initSwiper();
});
